import { connect } from 'react-redux';

import { changeOrderMembership } from '../actions';
import MembershipQueryParamCheck from '../components/MembershipQueryParamCheck';

const mapStateToProps = state => {
  return {
    hasSavedCart: state.hasSavedCart,
    hasMembership: state.currentOrder.membership_order || state.subscribed,
  };
};

const mapDispatchToProps = dispatch => ({
  turnOnMembership: () => {
    dispatch(changeOrderMembership(true));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipQueryParamCheck);
